<template>

    <div aria-label="Page navigation" v-if="links.next">
        <ul class="pagination justify-content-center mt-5">
            <li class="page-item" :class="{disabled: links.prev === null}">
                <inertia-link class="page-link" :href="links.prev">
                    <i class="bi bi-chevron-left"></i>
                    {{ __('vorherige Seite') }}
                </inertia-link>
            </li>
            <li class="page-item" :class="{disabled: links.next === null}">
                <inertia-link class="page-link" :href="links.next">
                    {{ __('nächste Seite') }}
                    <i class="bi bi-chevron-right"></i>
                </inertia-link>
            </li>
        </ul>
    </div>

</template>

<script>
    export default {
        props: [
            'links'
        ],
    }
</script>